import {
    InputAdornment,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    useTheme
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {checkValueWithInterval} from "../../../component/Utils";
import {CURRENCY_REG_EXP, DECIMAL_5_DIGITS_REG_EXP, INTEGER_REG_EXP} from "../../../component/Constants";

interface AncillariesProps {
    ancillaries: any[],
    ancillaryNameList: any[],
    setAncillaries: Function,
    errorMessage: any,
    setErrorMessage: Function
}


const Ancillaries = ({
                         ancillaries,
                         ancillaryNameList,
                         setAncillaries,
                         errorMessage,
                         setErrorMessage
                     }: AncillariesProps) => {
    const theme = useTheme();
    const accentColor = theme.palette.accent.main;
    const {t} = useTranslation(['salesmarketing', 'translation']);

    function handleAncillaryChange(id: number, field: string, value: any) {
        if (value !== "") {
            // reset errors
            let copyErrMsg = {...errorMessage};
            if (field === "discount" || field === "amount") {
                delete copyErrMsg["discount" + id];
                delete copyErrMsg["amount" + id];
            } else {
                delete copyErrMsg[field + id];
            }
            setErrorMessage(copyErrMsg);
        } /*else {
            let copyErrMsg = {...errorMessage};
            copyErrMsg[field+id] = t('salesmarketing:promo.createForm.requiredCheck');
            setErrorMessage(copyErrMsg);
        }*/
        let result;
        if(field==='name'){
            result = ancillaries.map((s: any) => s.id === id ? {...s, ida: value, code: ancillaryNameList.find((an:any)=>an.id === value)?.code, name: ancillaryNameList.find((an:any)=>an.id === value)?.name} : s)
        }
        else{
            result = ancillaries.map((s: any) => s.id === id ? {...s, [field]: value} : s);
        }
        setAncillaries(result);
    }

    function deleteAncillary(id: number) {
        let filteredList = ancillaries.filter((s: any) => s.id !== id);
        setAncillaries(filteredList);
        let copyErrMsg = {...errorMessage};
        delete copyErrMsg["discount" + id];
        delete copyErrMsg["amount" + id];
        delete copyErrMsg["name" + id];
        setErrorMessage(copyErrMsg);

        if (filteredList.length === 0)
            setErrorMessage('')
    }

    return (
        <TableContainer sx={{paddingTop: "10px"}}>
            <Table aria-label="ancillaries-table">
                <TableHead>
                    <TableRow>
                        <TableCell>{t('salesmarketing:promo.ancillaryPromo.name')}</TableCell>
                        <TableCell>{t('salesmarketing:promo.ancillaryPromo.discount')}</TableCell>
                        <TableCell>{t('salesmarketing:promo.ancillaryPromo.amount')}</TableCell>
                        <TableCell>{t('salesmarketing:promo.ancillaryPromo.delete')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ancillaries.map((row: any, index: number) => (
                        <TableRow
                            key={"sub" + index}
                        >
                            <TableCell width={"45%"}>
                                <TextField
                                    //label={t('salesmarketing:promo.ancillaryPromo.name')}
                                    fullWidth
                                    name="ancillaryName"
                                    required
                                    select
                                    value={row.ida}
                                    onChange={(e) => handleAncillaryChange(row.id, "name", e.target.value)}
                                    error={errorMessage && !!errorMessage["name" + row.id]}
                                    helperText={errorMessage && errorMessage["name" + row.id]}>
                                    <MenuItem key={""} value={""}/>
                                    {ancillaryNameList?.map((a: any) => (
                                        <MenuItem key={a.id} value={a.id} disabled={ancillaries.find((anc:any)=>parseInt(anc.ida)=== a.id)!== undefined}>
                                            {a.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    //label={t('salesmarketing:promo.ancillaryPromo.discount')}
                                    required
                                    disabled={!!row.amount}
                                    placeholder={row.amount ? "--" : ""}
                                    fullWidth
                                    name="ancillaryDiscount"
                                    value={row.discount}
                                    onChange={(e) => {
                                        if (e.target.value === "" || INTEGER_REG_EXP.test(e.target.value)) {
                                            handleAncillaryChange(row.id, "discount", checkValueWithInterval(e.target.value, 1, 100))
                                        }
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                    }}
                                    error={errorMessage && !!errorMessage["discount" + row.id]}
                                    helperText={errorMessage && errorMessage["discount" + row.id]}
                                />

                            </TableCell>
                            <TableCell>
                                <TextField
                                    //label={t('salesmarketing:promo.ancillaryPromo.amount')}
                                    required
                                    disabled={!!row.discount}
                                    placeholder={row.discount ? "--" : ""}
                                    fullWidth
                                    name="ancillaryAmount"
                                    value={row.amount}
                                    onChange={(e) => {
                                        if (e.target.value === "" || CURRENCY_REG_EXP.test(e.target.value) ||e.target.value.startsWith(',') ||e.target.value.startsWith('.')) {
                                            handleAncillaryChange(row.id, "amount", checkValueWithInterval(e.target.value, 0, 1000000))
                                        }
                                    }}
                                    error={errorMessage && !!errorMessage["amount" + row.id]}
                                    helperText={errorMessage && errorMessage["amount" + row.id]}
                                />
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    aria-label="delete"
                                    onClick={() => deleteAncillary(row.id)}
                                >
                                    <DeleteRoundedIcon sx={{color: accentColor}}/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default Ancillaries;